import type { ComponentProps, KeyboardEvent } from "react"

export function closeIconButton(onClose: () => void): ComponentProps<"svg"> {
  return {
    role: "button",
    tabIndex: 0,
    "aria-label": "Close",
    className: "size-4 cursor-pointer rounded-sm text-foreground-muted outline-none focus-visible:ring-3 focus-visible:ring-ring/50",
    ...iconButtonActivation(onClose),
  }
}

export function iconButtonActivation(onActivate: () => void) {
  return {
    onClick: onActivate,
    onKeyDown: (event: KeyboardEvent<SVGSVGElement>) => {
      if (event.key !== "Enter" && event.key !== " ") return
      event.preventDefault()
      onActivate()
    },
  }
}
